import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { LearnMoreOption } from '~/helpers/enums';
import { SUPPORT_LINK } from '../../helpers/constants';
import { userShape } from '../../helpers/propTypeShapes';
import trackMixPanelEvent from '../../helpers/trackMixPanelEvent';
import useDisableVideoDownload from '../../helpers/useDisableVideoDownload';
import ListButton from '../ListButton';
import useDownloadConversion from './useDownloadConversion';
import useDownloadRaw from './useDownloadRaw';

const learnMore = [
  { label: LearnMoreOption.LEARN_MORE, onClick: () => window.open(SUPPORT_LINK.EXPORT_RECORDINGS_CLIPS) },
];
export default function DownloadButtonWithConversions({ namingConvention, downloadFile, newTitle, pagePath }) {
  const { id, title, user, startedAt, createdAt, durationMillis, durationSeconds, outfile, file, m3u8Url } =
    downloadFile ?? {};
  const { name } = user ?? {};
  const { downloadRawOption, eventName, downloadDuration } = useDownloadRaw({
    namingConvention,
    outfile,
    file,
    m3u8Url,
    title,
    name,
    createdAt,
    durationMillis,
    startedAt,
    newTitle,
    durationSeconds,
  });
  const { onLoadConversionStatus, conversionOptions, downloadRequestedModal } = useDownloadConversion({
    id,
    namingConvention,
    durationSeconds,
    durationMillis,
    pagePath,
  });
  const { disableRightClickFunc, isDownloadsEnabled, tooltip } = useDisableVideoDownload();
  const [options, setOptions] = useState([]);

  const handleDownloadClick = () => {
    trackMixPanelEvent(eventName, { Duration: downloadDuration });
    onLoadConversionStatus();
  };

  useEffect(() => {
    setOptions([downloadRawOption, conversionOptions, learnMore]);
  }, [conversionOptions, downloadRawOption]);

  if (!downloadFile) {
    return null;
  }
  return (
    <>
      <ListButton
        id={downloadFile.id}
        type="download"
        options={options}
        label="Download"
        onContextMenu={disableRightClickFunc}
        onClick={handleDownloadClick}
        tooltip={tooltip}
        isDisabled={!isDownloadsEnabled}
      />
      {downloadRequestedModal}
    </>
  );
}
DownloadButtonWithConversions.defaultProps = {
  namingConvention: '',
  pagePath: '',
};

DownloadButtonWithConversions.propTypes = {
  downloadFile: PropTypes.shape({
    createdAt: PropTypes.number,
    durationMillis: PropTypes.number,
    durationSeconds: PropTypes.number,
    file: PropTypes.string,
    m3u8Url: PropTypes.string,
    outfile: PropTypes.string,
    title: PropTypes.string.isRequired,
    startedAt: PropTypes.number,
    user: userShape,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  namingConvention: PropTypes.string,
  newTitle: PropTypes.string.isRequired,
  pagePath: PropTypes.string,
};
